import { useState } from "react";
import { CheckCircle2, X } from "lucide-react";
import { useSubscription } from "@/hooks/useSubscription";
import { useUserId } from "@/hooks/useUserId";
import { PRODUCT_TO_TIER } from "@/constants/stripeTiers";
import { shouldShowPostTrialBanner } from "@/lib/subscription";

const dismissedKey = (userId: string) =>
  `viraluj_post_trial_banner_dismissed_${userId}`;

const TIER_LABEL: Record<string, string> = {
  starter: "Starter",
  pro: "Pro",
};

const TIER_LIMITS_COPY: Record<string, string> = {
  starter: "3 inspiracji, 3 konkurentów i 15 generacji miesięcznie",
  pro: "6 inspiracji, 6 konkurentów i 60 generacji miesięcznie",
};

const PostTrialBanner = () => {
  const userId = useUserId();
  const { subscribed, isTrial, subscriptionTrialEnd, productId } = useSubscription();

  const initialDismissed = userId
    ? localStorage.getItem(dismissedKey(userId)) === "true"
    : true;
  const [dismissed, setDismissed] = useState(initialDismissed);

  if (!userId) return null;

  const visible = shouldShowPostTrialBanner(
    { subscribed, isTrial, subscriptionTrialEnd },
    dismissed
  );
  if (!visible) return null;

  const tierKey = productId ? PRODUCT_TO_TIER[productId] : null;
  const tierLabel = tierKey ? TIER_LABEL[tierKey] : null;
  const limitsCopy = tierKey ? TIER_LIMITS_COPY[tierKey] : null;
  if (!tierLabel || !limitsCopy) return null;

  const handleDismiss = () => {
    localStorage.setItem(dismissedKey(userId), "true");
    setDismissed(true);
  };

  return (
    <div className="bg-emerald-50 border-b border-emerald-200 px-4 py-2.5 flex items-center justify-center gap-3 text-sm">
      <CheckCircle2 className="w-4 h-4 text-emerald-600 flex-shrink-0" />
      <span className="text-emerald-900">
        🎉 Plan <strong>{tierLabel}</strong> aktywny — masz teraz dostęp do{" "}
        {limitsCopy}.
      </span>
      <button
        type="button"
        onClick={handleDismiss}
        aria-label="Zamknij powiadomienie"
        className="text-emerald-700 hover:text-emerald-900 flex-shrink-0"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default PostTrialBanner;
